import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

class SignupCampaignState extends APIRequestState {
  putRequest(urlId, ...params) {
    return this.ctx.sdk.post(`/me/signup-campaign/${urlId}`, ...params);
  }
}

class CampaignsState {
  @lazyInitialize @nonenumerable signupCampaign = new SignupCampaignState(this.ctx);

  @nonenumerable listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default CampaignsState;



// WEBPACK FOOTER //
// ./spa/state/campaigns.jsx